import $ from 'jquery';

import { View } from 'backbone';
import { Model } from 'backbone';
import template from 'behaviors/properties/main/notify/attachments-modal.ejs';
import selectFieldModalView from 'common-views/SelectFieldModalView.js';
import util     from 'util/Util.js';
import constants from 'Constants.js'

class AttachmentsModalView extends View {

    initialize( opts ) {
        this.options = opts || {};

        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        let attachments = opts.model.attributes.data? opts.model.attributes.data : {};

        if (!this.model.get('maxSizeLegend')){
            this.model.set('maxSizeLegend', 'Max size of attachments per email is 8 MB', {silent:true});
        }
        if (!this.model.get('insertAttachmentSelected')){
            this.model.set('insertAttachmentSelected', attachments.insertAttachmentSelected? attachments.insertAttachmentSelected : '', {silent:true});
        }
        if (!this.model.get('insertAttachment')){
            this.model.set('insertAttachment', attachments.insertAttachment? attachments.insertAttachment : '', {silent:true});
        }
        this.model.set('insertCheck', util.isTrue(attachments.insertCheck), {silent:true});

        if (!this.model.get('printAttachmentSelected')){
            this.model.set('printAttachmentSelected', attachments.printAttachmentSelected ? attachments.printAttachmentSelected: '', {silent:true});
        }
        if (!this.model.get('printAttachment')){
            this.model.set('printAttachment', attachments.printAttachment ? attachments.printAttachment: '', {silent:true});
        }
        this.model.set('printCheck', util.isTrue(attachments.printCheck), {silent:true});

        if (!this.model.get('existingInstanceAttachmentSelected')){
            this.model.set('existingInstanceAttachmentSelected', attachments.existingInstanceAttachmentSelected? attachments.existingInstanceAttachmentSelected: '', {silent:true});
        }
        if (!this.model.get('existingInstanceAttachment')){
            this.model.set('existingInstanceAttachment', attachments.existingInstanceAttachment? attachments.existingInstanceAttachment: 'false', {silent:true});
        }
        this.model.set('instanceCheck', util.isTrue(attachments.instanceCheck), {silent:true});

        return this;
    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        if (propVal) {
            $('#'+propName+'Button').attr('disabled', false);
            $('#'+propName+'Button').attr('readOnly', false);
        } else {
            $('#'+propName+'Button').attr('disabled', true);
            $('#'+propName+'Button').attr('readOnly', true);
        }
//      Do not update this properties, since this will override user's selection values
//        this.model.set( propName, propVal );
        this.updateCheckFlags (propName, propVal);
        $('button.btn-select-field').button("enabled");
    }

    updateCheckFlags(prop, value){
        switch (prop){
            case 'insertAttachment':
                this.model.set('insertCheck', value, {silent: true});
                if (!value || !this.model.has('insertAttachmentSelected')) {
                    this.model.set('insertAttachmentSelected', '', {silent: true});
                    this.model.set('insertAttachment', '', {silent: true});
                }
                break;
            case 'printAttachment':
                this.model.set('printCheck', value, {silent: true});
                if (!value || !this.model.has('printAttachmentSelected')) {
                    this.model.set('printAttachmentSelected', '', {silent: true});
                    this.model.set('printAttachment', '', {silent: true});
                }
                break;
            case 'existingInstanceAttachment':
                this.model.set('instanceCheck', value, {silent: true});
                if (!value || !this.model.has('existingInstanceAttachmentSelected')) {
                    this.model.set('existingInstanceAttachmentSelected', '', {silent: true});
                    this.model.set('existingInstanceAttachment', '', {silent: true});
                }
                break;
        }
    }


    showSelectModal(ev, section) {
        ev.preventDefault();
        let modalTitle = null;
        let responseField = '';
        const self = this;
        switch (section){
            case 'insert':
                modalTitle = 'Insert an Attachment - '+this.model.get('maxSizeLegend');
                responseField = ['insertAttachment', 'insertAttachmentSelected'];
                this.model.set("multipleSelectionEnabled", true, {SILENT:true});
                this.model.set("dataSelectedItemId", this.model.get('insertAttachment'), {silent:true});
                break;
            case 'print':
                modalTitle = 'Select a Page - '+this.model.get('maxSizeLegend');
                responseField = ['printAttachment', 'printAttachmentSelected'];
                 this.model.set("multipleSelectionEnabled", true, {SILENT:true});
                 this.model.set("dataSelectedItemId",this.model.get("printAttachment"), {silent:true});
                break;
            case 'instance':
                modalTitle = 'Select a Field - '+this.model.get('maxSizeLegend');
                responseField = ['existingInstanceAttachment'];
                this.model.set("multipleSelectionEnabled", false, {SILENT:true});
                this.model.set("dataSelectedItemId", this.model.get('existingInstanceAttachment'), {silent:true});
                break;
        }

        var sfModal = new selectFieldModalView( {model: this.model, mode: section,
            modalTitle: modalTitle} );
        sfModal.render().then((selectedField)=>{
            _.each(responseField, field =>{
                let _selectedField;
                if (section !== 'instance' || (selectedField && selectedField.key !== 'page_instance')){ //PF-6639 - Old Forms: Error on submit if form contains a notify command with Attachment Print enabled
                    _selectedField = selectedField;
                }
                self.model.set(field, _selectedField, {silent: true});
            });

        }).catch(err => {console.log(err)});
    }


    closeModal() {
        $('#attachments-modal').remove();
    }

    bindListEvent() {
        $('#insertAttachment').change((e)=>{
            this.updateCheckboxAttributes(e);
        });
        $('#printAttachment').change((e)=>{
            this.updateCheckboxAttributes(e);
        });
        $('#existingInstanceAttachment').change((e)=>{
            this.updateCheckboxAttributes(e);
        });
        $('#insertAttachmentButton').on('click', ( e ) => {
            this.showSelectModal(e, 'insert')
        });
        $('#printAttachmentButton').on('click', ( e ) => {
            this.showSelectModal(e, 'print')
        });
        $('#existingInstanceAttachmentButton').on('click', ( e ) => {
            this.showSelectModal(e, 'instance');
        });
    }

    unbindListEvent() {
        $('#insertAttachment').unbind();
        $('#printAttachment').unbind();
        $('#existingInstanceAttachment').unbind();
        $('#insertAttachmentButton').unbind();
        $('#printAttachmentButtton').unbind();
        $('#existingInstanceAttachmentButtton').unbind();
    }

    enableButtons(){
        $('#insertAttachmentButton').attr('disabled', !util.isTrue(this.model.get('insertCheck')));
        $('#insertAttachmentButton').attr('readOnly', !util.isTrue(this.model.get('insertCheck')));
        $('#printAttachmentButton').attr('disabled', !util.isTrue(this.model.get('printCheck')));
        $('#printAttachmentButton').attr('readOnly', !util.isTrue(this.model.get('printCheck')));
        $('#existingInstanceAttachmentButton').attr('disabled', !util.isTrue(this.model.get('instanceCheck')));
        $('#existingInstanceAttachmentButton').attr('readOnly', !util.isTrue(this.model.get('instanceCheck')));
    }

    getResponse () {
        let response = {};
        const getValues = (values, includeName = false) =>{
            let ids = values;

            if(values && Array.isArray(values) && values.length > 0){
                ids = [];
                _.each(values, value =>{
                    if(includeName){
                        ids.push(value.id + "," + value.name);
                    }
                    else{
                        ids.push(value.id);
                    }                    
                }); 

                ids = ids.join('|');
            }

            return ids;
        }
        response.insertAttachment = getValues(this.model.get('insertAttachment'));
        response.insertAttachmentSelected = response.insertAttachment;
        response.insertCheck = util.isTrue(this.model.get('insertCheck'))? 'true': 'false';
        response.printAttachment = getValues(this.model.get('printAttachment'), true);
        response.printAttachmentSelected = response.printAttachment;
        response.printCheck = util.isTrue(this.model.get('printCheck'))? 'true': 'false';
        response.existingInstanceAttachment = this.model.get('existingInstanceAttachment')?
            this.model.get('existingInstanceAttachment').id: '';
        response.existingInstanceAttachmentSelected = response.existingInstanceAttachment;
        response.instanceCheck = util.isTrue(this.model.get('instanceCheck'))? 'true': 'false';
        return response;
    }

    render() {
        let self = this;
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);

            // Show modal popup window
            this.dialog = $('#attachments-modal').dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 250,
                width: 385,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'OK',
                        'class': 'btn-select-field',
                        'disabled': true,
                        click: () => {
                            this.dialog.dialog("close");
                            this.closeModal();
                            resolve(self.getResponse());
                        }
                    },
                    {
                        text: 'Cancel',
                        'class': 'btn-addAssetCancel',
                        click: () => {
                            this.closeModal();
                            reject();
                        }
                    }
                ],
                close: () => {
                    this.closeModal();
                    self.unbindListEvent();
                    // TODO
                    this.closeModal();
                },
                open: () => {
                    self.bindListEvent();
                    self.enableButtons();
                }
            });

            $('div[role="dialog"]').draggable(constants.DEFAULT_DRAGGABLE_OPTIONS);
            this.delegateEvents();
            return this;
        });

    }
}

export default AttachmentsModalView;
